import knot from "./projects/knot.json";
import knotImage from "./graphics/knot.png";

const all = [{ ...knot, image: knotImage }] satisfies Project[];

export interface Project {
  id: string;
  title: string;
  description: string;
  longDescription?: string; // For the detail view
  image: string;
  badges: string[];
  links?: {
    label: string;
    url: string;
  }[];
  techStack?: string[]; // For the detail view
}

export const projects: Project[] = [
  ...all,
  {
    id: "origin-app",
    title: "The Origin App",
    description: "P2P Payments on Noble using Host Card Emulation and NFC.",
    longDescription:
      "Reimagining crypto payments with NFC technology. A seamless, contactless experience built on the Noble app-chain. We leveraged Host Card Emulation (HCE) on Android to simulate NFC tags, allowing devices to handshake and exchange signed transactions offline-first.",
    image:
      "https://images.unsplash.com/photo-1616499615673-92411043831d?q=80&w=2940&auto=format&fit=crop",
    badges: ["Featured Work 001", "Mobile"],
    techStack: [
      "React Native",
      "TypeScript",
      "Node.js",
      "Noble Chain",
      "NFC/HCE",
      "PostgreSQL",
    ],
    links: [
      { label: "Live Demo", url: "#" },
      { label: "Source Code", url: "#" },
    ],
  },
  {
    id: "account-abstraction-sdk",
    title: "Account Abstraction SDK",
    description:
      "A flutter framework for building ERC-4337 account abstraction flutter apps",
    image:
      "https://images.unsplash.com/photo-1658297063569-162817482fb6?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxlY29tbWVyY2UlMjB3ZWJzaXRlfGVufDF8fHx8MTc2NTYzNTUyMXww&ixlib=rb-4.1.0&q=80&w=1080",
    badges: ["Developer tool", "Dart"],
    techStack: ["Dart", "Flutter", "ERC-4337"],
  },
  {
    id: "web3-signers",
    title: "Web3 Signers Library",
    description:
      "A generic signing interface for smart accounts validation and EOAs",
    image:
      "https://images.unsplash.com/photo-1750056393306-ac672d0dbb8c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx3ZWIlMjBkZXNpZ24lMjBtb2NrdXB8ZW58MXx8fHwxNzY1NTk3OTA4fDA&ixlib=rb-4.1.0&q=80&w=1080",
    badges: ["Flutter Package", "Dart"],
    techStack: ["Dart", "Cryptography", "EIP-1271"],
  },
  {
    id: "eip-7702",
    title: "EIP-7702 / Flutter Implementation",
    description:
      "A dart library that enables flutter apps to adopt eip-7702 typed tx and delegation flows",
    image:
      "https://images.unsplash.com/photo-1605108222700-0d605d9ebafe?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2JpbGUlMjBhcHAlMjBpbnRlcmZhY2V8ZW58MXx8fHwxNzY1NTkyMzUxfDA&ixlib=rb-4.1.0&q=80&w=1080",
    badges: ["Library", "Dart"],
    techStack: ["Dart", "Flutter", "EIP-7702"],
  },
  {
    id: "eip-712",
    title: "EIP-712 Library",
    description:
      "Lightweight library for generating and signing structured typed data in dart.",
    image:
      "https://images.unsplash.com/photo-1658297063569-162817482fb6?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxlY29tbWVyY2UlMjB3ZWJzaXRlfGVufDF8fHx8MTc2NTYzNTUyMXww&ixlib=rb-4.1.0&q=80&w=1080",
    badges: ["Library", "Dart"],
    techStack: ["Dart", "EIP-712"],
  },
  {
    id: "eip-7579",
    title: "EIP-7579 Library",
    description:
      "A flutter package that brings support of modular smart-accounts to apps built on variance SDK",
    image:
      "https://images.unsplash.com/photo-1750056393306-ac672d0dbb8c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx3ZWIlMjBkZXNpZ24lMjBtb2NrdXB8ZW58MXx8fHwxNzY1NTk3OTA4fDA&ixlib=rb-4.1.0&q=80&w=1080",
    badges: ["Library", "Dart"],
    techStack: ["Dart", "Flutter", "EIP-7579"],
  },
  {
    id: "x402-client",
    title: "X402 Client Library",
    description:
      "Lightweight library that helps flutter apps manage paid APIs lifecycle easily.",
    image:
      "https://images.unsplash.com/photo-1750056393306-ac672d0dbb8c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx3ZWIlMjBkZXNpZ24lMjBtb2NrdXB8ZW58MXx8fHwxNzY1NTk3OTA4fDA&ixlib=rb-4.1.0&q=80&w=1080",
    badges: ["Library", "Dart"],
    techStack: ["Dart", "Flutter", "API"],
  },
  {
    id: "tiny-vector-db",
    title: "Vector Database",
    description: "A Tiny Vector Database implemented in Go",
    image:
      "https://images.unsplash.com/photo-1750056393306-ac672d0dbb8c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx3ZWIlMjBkZXNpZ24lMjBtb2NrdXB8ZW58MXx8fHwxNzY1NTk3OTA4fDA&ixlib=rb-4.1.0&q=80&w=1080",
    badges: ["Databases", "Go"],
    techStack: ["Go", "Vector DB"],
  },
  {
    id: "ens-normalize",
    title: "ENS Normalization",
    description: "Lightweight Ethereum Name Service Normalization Library",
    image:
      "https://images.unsplash.com/photo-1750056393306-ac672d0dbb8c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx3ZWIlMjBkZXNpZ24lMjBtb2NrdXB8ZW58MXx8fHwxNzY1NTk3OTA4fDA&ixlib=rb-4.1.0&q=80&w=1080",
    badges: ["Library", "Dart"],
    techStack: ["Dart", "ENS", "Ethereum"],
  },
  {
    id: "pathway",
    title: "Pathway",
    description:
      "A cross-chain USDC bridge client/relayer connecting EVM networks to Noble app-chain",
    image:
      "https://images.unsplash.com/photo-1750056393306-ac672d0dbb8c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx3ZWIlMjBkZXNpZ24lMjBtb2NrdXB8ZW58MXx8fHwxNzY1NTk3OTA4fDA&ixlib=rb-4.1.0&q=80&w=1080",
    badges: ["App", "TypeScript"],
    techStack: ["TypeScript", "Bridge", "USDC"],
  },
];
